import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLocalAuth } from '../../hooks/useLocalAuth';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { user, loading, initializeAuth } = useLocalAuth();
  const location = useLocation();
  const [authInitialized, setAuthInitialized] = React.useState(false);

  useEffect(() => {
    // Initialize auth
    initializeAuth();
    setAuthInitialized(true);
  }, [initializeAuth]);

  // Show loading screen while auth is being checked
  if ((loading && authInitialized) || !authInitialized) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-600">Anmeldung wird überprüft...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};